import { render, staticRenderFns } from "./myAddresses.vue?vue&type=template&id=50b306d6&"
import script from "./myAddresses.vue?vue&type=script&lang=js&"
export * from "./myAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports